// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Mousewheel, Autoplay, Pagination, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import { useEffect, useRef, useState } from 'react';

import { translations } from '../locales/lang';
import useResponsiveFlags from '../hooks/useResponsiveFlags';

import styles from '../assets/styles/Header.module.css';
import useLanguage from '../hooks/useLanguage';

const Header = () => {
    const { isMobile, isTablet } = useResponsiveFlags();
    const [currendIndex, setCurrentIndex] = useState(0);
    const swiperRef = useRef(null);
    const { language } = useLanguage();



    const banners = [
        {
            image: isMobile ? '/images/header/banner-1-mobile.jpg' : isTablet ? '/images/header/banner-1-tablet.jpg' : '/images/header/banner-1.jpg',
            title: translations[language].header.headerTitle,
            desc: translations[language].header.headerDetail,
            bgColor: !(isMobile || isTablet) ? '90deg, rgba(12, 166, 237, 0) 33.95%, rgba(12, 166, 237, 0.765625) 49.2%, #0CA6ED 65.87%' : '180deg, rgba(12, 166, 237, 0) 35.71%, rgba(12, 166, 237, 0.765625) 55.01%, #0CA6ED 76.12%'
        },
        // {
        //     image: isMobile ? '/images/header/banner-3-mobile.jpg' : isTablet ? '/images/header/banner-3-tablet.jpg' : '/images/header/banner-3.jpg',
        //     title: 'Ứng dụng quản lý học tập đa nền tảng',
        //     desc: '<b>LCMS i-School</b> giúp bạn quản lý giáo dục đào tạo hiệu quả hơn khi bạn có thể dạy và học thuận tiện hơn trên nhiều nền tảng khác nhau.',
        //     bgColor: !(isMobile || isTablet) ? '90deg, rgba(252, 175, 23, 0) 43.2%, rgba(252, 175, 23, 0.765625) 56.99%, #FCAF17 72.05%' : '180deg, rgba(252, 175, 23, 0) 43.2%, rgba(252, 175, 23, 0.765625) 56.99%, #FCAF17 72.05%'
        // },
        // {
        //     image: isMobile ? '/images/header/banner-2-mobile.jpg' : isTablet ? '/images/header/banner-2-tablet.jpg' : '/images/header/banner-2.jpg',
        //     title: 'Cầu nối giữa giáo dục đào tạo và công nghệ',
        //     desc: '<b>LCMS i-School</b> tăng cường tương tác giữa nhà trường, giáo viên, học sinh và phụ huynh.',
        //     bgColor: !(isMobile || isTablet) ? '90deg, rgba(127, 181, 57, 0.00) 43.2%, rgba(127, 181, 57, 0.77) 56.99%, #7FB539 72.05%' : '180deg, rgba(127, 181, 57, 0.00) 43.2%, rgba(127, 181, 57, 0.77) 56.99%, #7FB539 72.05%'
        // },
    ];

    return (
        <section className={styles.container} id='header-swiper-container'>
            {/* <Swiper
                ref={swiperRef}
                // autoplay={{ delay: 3000 }}
                direction="vertical"
                effect="fade"
                fadeEffect={{ crossFade: true }}
                speed={1000}
                slidesPerView={1}
                mousewheel={{ releaseOnEdges: true }}
                // pagination={{ clickable: true }}
                modules={[Mousewheel, Autoplay, Pagination, EffectFade]}
                style={{ height: '100%' }}
                onSlideChange={(swiper) => setCurrentIndex(swiper.realIndex)}
                className={styles.swiper}
            > */}
            {banners.map((item, idx) => (
                // <SwiperSlide key={idx}>

                // </SwiperSlide>
                <div className={styles.image}>
                    <div className={styles.marsk} style={{ '--bgColor': item.bgColor }} />
                    <img src={item.image} alt="banner" />
                    <div className={styles.content}>
                        <div className={`${styles.title} ${currendIndex === idx ? 'aos-animate' : ''}`} data-aos="fade-up" >{item.title}</div>
                        <div
                            data-aos="fade-up"
                            className={`${styles.description} ${currendIndex === idx ? 'aos-animate' : ''}`}
                            dangerouslySetInnerHTML={{ __html: item.desc }}
                        />
                    </div>
                </div>
            ))}
            {/* </Swiper> */}
            {/* <div className={styles.customPagination}>
                {banners.map((_, index) => (
                    <div
                        key={index}
                        className={`${styles.dot} ${currendIndex === index ? styles.active : ''}`}
                        onClick={() => swiperRef.current?.swiper?.slideTo(index)}
                    />
                ))}
            </div> */}
        </section>
    );
};

export default Header;
